import AdminImageFallback from "../components/AdminImageFallback";
import SpecialActionsMenu from "./SpecialActionsMenu";

const money = (value) => `$${Number(value || 0).toFixed(2)}`;

const dateRange = (special) => {
  const options = { month: "short", day: "numeric" };
  const start = special.starts_at
    ? new Date(special.starts_at).toLocaleDateString(undefined, options)
    : "No start";
  const end = special.ends_at
    ? new Date(special.ends_at).toLocaleDateString(undefined, options)
    : "No end";

  return `${start} - ${end}`;
};

const statusDescription = (special) => {
  if (!special.is_active) {
    return "Inactive draft";
  }

  if (!special.ends_at || special.status !== "active") {
    return String(special.status || "active").replaceAll("_", " ");
  }

  const days = Math.ceil(
    (new Date(special.ends_at) - new Date()) / 86400000,
  );

  return days <= 0
    ? "Ends today"
    : `Ends in ${days} day${days === 1 ? "" : "s"}`;
};

function SpecialCard({
  special,
  isActionsOpen,
  onToggleActions,
  onCloseActions,
  onEdit,
  onDelete,
  onToggleActive,
  onToggleFeatured,
  onDuplicate,
  onPreview,
}) {
  const progress = special.maximum_redemptions
    ? Math.min(
        100,
        (Number(special.redemption_count || 0) /
          Number(special.maximum_redemptions)) *
          100,
      )
    : 0;

  return (
    <article className="special-card">
      <div className="special-card__media">
        <AdminImageFallback
          src={special.image_url}
          alt={special.name}
          className="special-card__media-image"
          uploadedImageClassName="special-card__media-image--uploaded"
          fallbackClassName="special-card__media-image--fallback"
        />

        {special.badge_text && <b>{special.badge_text}</b>}
      </div>

      <div className="special-card__body">
        <div className="special-card__top">
          <div>
            <span className={`special-status special-status--${special.status}`}>
              {special.status}
            </span>
            <h3>{special.name}</h3>
          </div>
        </div>

        <p>{special.short_description || "No short description yet."}</p>

        <dl>
          <div>
            <dt>Type</dt>
            <dd>{String(special.special_type).replaceAll("_", " ")}</dd>
          </div>
          <div>
            <dt>Dates</dt>
            <dd>{dateRange(special)}</dd>
          </div>
          <div>
            <dt>Regular</dt>
            <dd>{money(special.base_subtotal)}</dd>
          </div>
          <div>
            <dt>Special</dt>
            <dd>{money(special.final_price)}</dd>
          </div>
        </dl>

        <div className="special-card__badges">
          {special.is_featured && <span>Featured</span>}
          {special.is_public && <span>Public</span>}
          {special.requires_code && <span>Code: {special.promo_code}</span>}
          <span>
            {special.item_count || 0} item{special.item_count === 1 ? "" : "s"}
          </span>
        </div>

        {special.maximum_redemptions && (
          <div className="special-redemption">
            <span style={{ width: `${progress}%` }} />
            <small>
              {special.redemption_count || 0}/{special.maximum_redemptions} used
            </small>
          </div>
        )}

        <footer className="admin-special-card__footer">
          <span className="admin-special-card__status-note">
            {statusDescription(special)}
          </span>

          <div className="admin-special-card__footer-actions">
            <button
              type="button"
              className="btn btn--secondary btn--small"
              onClick={() => onToggleActive(special)}
            >
              {special.is_active ? "Deactivate" : "Activate"}
            </button>

            <SpecialActionsMenu
              special={special}
              isOpen={isActionsOpen}
              onToggle={onToggleActions}
              onClose={onCloseActions}
              onEdit={onEdit}
              onPreview={onPreview}
              onToggleFeatured={onToggleFeatured}
              onDuplicate={onDuplicate}
              onDelete={onDelete}
            />
          </div>
        </footer>
      </div>
    </article>
  );
}

export default SpecialCard;